export const SELECTORS = {
  CONTAINER: 'js-winback-offer',
  LOADING: 'js-winback-offer-loading',
  SUCCESS: 'js-winback-offer-success',
  REDIRECT_TEXT: 'js-winback-offer-redirect-text',
  NOT_ELIGIBLE: 'js-winback-offer-not-eligible',
  ERROR: 'js-winback-offer-error',
  ERROR_TEXT: 'js-winback-offer-error-text'
};

export const REDIRECT_DELAY_MS = 5000;

export const REDIRECT_TEXT_TEMPLATE = 'Redirecting in {seconds}s...';

export const MESSAGES = {
  INVALID_LINK: 'Invalid link. Please use the original link you received.',
  GENERIC: 'Something went wrong, please try again later.'
};
